import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-coaching',
  templateUrl: './business-coaching.component.html',
  styleUrls: ['./business-coaching.component.scss']
})
export class BusinessCoachingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
